import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminPanelHeader = ({ profile }) => {
  const intl = useIntl();

  const userName = profile.name ? `, ${profile.name.split(' ')[0]}` : null;

  return (
    <header className="page-header">
      <div className="page-title">
        <h2>
          {intl.formatMessage({ defaultMessage: 'Hello{username}' }, { username: userName })}
        </h2>
      </div>
    </header>
  );
};

AdminPanelHeader.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default AdminPanelHeader;
